const Settings = () =>{
    return (<>Settings</>)
}

export default Settings